/**
 * At a clinic with CCM care plan time on, every new time entry covers a clinical note the nurse saved
 * first: the note form hands the note to the time form, which saves the entry with the note's id and
 * welby-micro-service links the two.
 */

/** The clinical note a new time entry covers, as the note form hands it to the time form. */
export interface LinkedClinicalNote {
  id: string;
  /** The note's HTML, as saved. Shown as plain text only. */
  content: string;
}

/** The codes welby-micro-service refuses a time entry with when its clinical note is missing or cannot be linked. */
export const CLINICAL_NOTE_ERROR_CODES = [
  'CLINICAL_NOTE_REQUIRED',
  'CLINICAL_NOTE_NOT_FOUND',
  'CLINICAL_NOTE_OTHER_PATIENT',
  'CLINICAL_NOTE_OTHER_AUTHOR',
  'CLINICAL_NOTE_ALREADY_LINKED',
  'CLINICAL_NOTE_CHANGED',
] as const;

export type ClinicalNoteErrorCode = (typeof CLINICAL_NOTE_ERROR_CODES)[number];

/**
 * The result the time form closes with when it is cancelled at a clinic where time needs a note: the
 * chart timer keeps its minutes, so the nurse can write the note and save the time from it.
 */
export const CLINICAL_TIME_KEPT_FOR_NOTE = 'kept-for-note';
